class Precision {
    cdns = [];
    isRefreshable = false;
    minRefreshWindowMs = -1;
    isEnabled = false;

    constructor() {
        Object.seal(this);
    }
}

export default Precision;
